export const sumByDate = (data) => {
  const map: Record<string, number> = {};

  for (const item of data) {
    const value = Number(item.number) || 0;

    if (!map[item.date]) {
      map[item.date] = 0;
    }

    map[item.date] += value;
  }

  return Object.entries(map).map(([date, number]) => ({
    date,
    number,
  }));
};

export const sumByMonth = (data) => {
  const map: Record<string, number> = {};

  for (const item of data) {
    const value = Number(item.number) || 0;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [day, month, year] = item.date.split('-');
    const monthYear = `${month}-${year}`;

    if (!map[monthYear]) {
      map[monthYear] = 0;
    }

    map[monthYear] += value;
  }

  return Object.entries(map).map(([date, number]) => ({
    date,
    number,
  }));
};
